<div class="container-fluid page-wrap p-0 pb-5" *ngIf="galleryPhotos?.length > 0">
    <div class="row">
        <div class="col-12">
            <div class="gallery-header pb-3 pb-lg-4 ps-0 ps-lg-4">GALLERY</div>
        </div>
    </div>
    <div class="row gallery-row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-2 g-md-4 px-0 px-lg-3">
        <div class="col-6 col-md-3" *ngFor="let item of galleryPhotos; index as i">
            <div class="img-block-cont">
                <div class="gallery-card" (click)="viewSlider(i)">
                    <img class="gallery-img"
                        [src]="(cdnImagePath + item?.large_image) || commonImagePath+ 'image_not_found.webp'"
                        [alt]="item.large_image" (error)="onImageError($event)" loading="lazy">
                </div>
            </div>
        </div>
    </div>
    <div class="gallery-slider" *ngIf="showSlider">
        <button type="button" class="col-2 ms-2" (click)="prevSlide()">
            <i class="fa fa-angle-left"></i>
        </button>
        <div class="col-md-5 col-sm-6">
            <div class="d-flex justify-content-end mb-1">
                <div type="button" (click)="closeSlider()">
                    <i class="fa fa-close"></i>
                </div>
            </div>
            <img class="gallery-img" [src]="(cdnImagePath + imageObject) || commonImagePath+ 'image_not_found.webp'"
                [alt]="imageObject" (error)="onImageError($event)" loading="lazy">
            <div class="d-flex justify-content-between">
                <p>{{imageObject}}</p>
                <p>{{currentIndex + 1}} of {{galleryPhotos?.length}}</p>
            </div>
        </div>
        <button class="col-2 me-2" type="button" (click)="nextSlide()">
            <i class="fa fa-angle-right"></i>
        </button>
    </div>
</div>